/* eslint-disable max-len */

export class CorrenteCadastroZCO {
    constructor(dependentes) {
        this.dependentes = dependentes;
        this.arrayMsgsErro = [];
        this.quantidadeTotalDependentes = dependentes.length;
        this.arrayParentesco = ['ESPOSO(A)', 'PAI', 'MAE', 'GENRO', 'NORA', 'FILHO(A)', 'NETO(A)', 'ENTEADO(A)'];
        this.arrayParentescoFilhosNetosEnteados = ['FILHO(A)', 'NETO(A)', 'ENTEADO(A)'];
        this.arrayComGrauParentesco = ['ESPOSO(A)', 'PAI', 'MAE', 'GENRO', 'NORA'];
        this.quantidadeDependenteAte64 = (() => {
            const qtdAte64 = dependentes.filter(dependente => dependente.Idade < 65).length;
            const parentescoAte64 = dependentes.filter(dependente => dependente.Idade < 65 && !this.arrayParentesco.includes(dependente.Parentesco)).map(({ Parentesco }) => Parentesco);

            return {
                qtdAte64,
                parentescoAte64
            };
        })(dependentes);
        this.quantidadeDependenteMaior65 = (() =>{
            const qtd65 = dependentes.filter(dependente => dependente.Idade >= 65).length;
            const parentesco65 = dependentes.filter(dependente => (dependente.Idade >= 65 ) &&  !this.arrayComGrauParentesco.includes(dependente.Parentesco)).map(({ Parentesco }) => Parentesco);
            const parentesco65PaisMaesE1 = dependentes.filter(dependente => (dependente.Idade >= 65 ) &&  this.arrayComGrauParentesco.includes(dependente.Parentesco)).map(({ Parentesco }) => Parentesco);

            return {
                qtd65,
                parentesco65,
                parentesco65PaisMaesE1
            };
        })(dependentes);
        this.quantidadeDependentesFilhoNetoMais30 = (() => dependentes.filter(dependente => (dependente.Idade > 30) && (this.arrayParentescoFilhosNetosEnteados.includes(dependente.Parentesco))).length)(dependentes);
        this.quantidadeDependentesComGrauParentesco = (() => dependentes.filter(dependente => this.arrayComGrauParentesco.includes(dependente.Parentesco)).length)(dependentes);
    }

    possui8Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === 8) {
            this.arrayMsgsErro.push('Este plano permite apenas 8 dependentes.');
        }

        return this;
    }

    verificaTipoParentesco() {
        if(this.quantidadeTotalDependentes < 3){ 
            this.arrayMsgsErro.pop(); 
        } else if(this.quantidadeTotalDependentes > 2 && this.quantidadeTotalDependentes <= 5){ // de 3 a 5 dependentes
            if(this.quantidadeDependenteMaior65.qtd65 <= 2){
                this.arrayMsgsErro.pop();
            } else if(this.quantidadeDependenteMaior65.qtd65 > 2 && this.quantidadeDependenteMaior65.qtd65 <= 5){
                if(this.quantidadeDependenteMaior65.parentesco65PaisMaesE1.length > 2 && this.quantidadeDependentesFilhoNetoMais30 > 0){
                    this.arrayMsgsErro.push('Para este plano, caso haja dependentes do tipo FILHO, NETO e ENTEADO que tenham mais de 30 anos, só será possível inserir novos dependentes de qualquer grau de parentesco que tenham menos que 65 anos desde que o limite de 2 dependentes de 65 anos não tenha sido atingido.');
                }else if ( this.quantidadeDependentesComGrauParentesco >= this.quantidadeDependenteMaior65.qtd65 && 
                    this.quantidadeDependenteMaior65.parentesco65.length === 0) {
                    this.arrayMsgsErro.pop();
                } else {
                    this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 65 anos com ou sem grau de parentesco,' + 
                        'para adicionar mais dependentes com idade maior ou igual a 65 anos é preciso respeitar o grau de parentesco dos tipos ' + 
                        'Pai, Mãe, Cônjuge, Genro e Nora.');
                }
            }
        } else if(this.quantidadeTotalDependentes > 5 && this.quantidadeTotalDependentes <= 8){ //de 6 a 8 dependentes
            if(this.quantidadeDependenteMaior65.qtd65 <= 2){
                this.arrayMsgsErro.pop();
            } else{
                if(this.quantidadeDependentesComGrauParentesco < this.quantidadeDependenteMaior65.qtd65){
                    this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 65 anos com ou sem grau de parentesco,' + 
                    'para adicionar mais dependentes com idade maior ou igual a 65 anos é preciso respeitar o grau de parentesco dos tipos' + 
                    'Pai, Mãe, Cônjuge, Genro e Nora.');
                }else if (this.quantidadeDependentesComGrauParentesco >= this.quantidadeDependenteMaior65.qtd65 && 
                    this.quantidadeDependenteMaior65.parentesco65.length > 0) {
                    this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade menor ou igual a 64 anos sem grau de parentesco,' + 
                    'para adicionar mais dependentes com idade menor ou igual a 64 anos é preciso respeitar o grau de parentesco dos tipos ' + 
                    'Pai, Mãe, Cônjuge, Genro e Nora.');
                }  else if(this.quantidadeDependenteAte64.parentescoAte64.length > 2){
                    this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade menor ou igual a 64 anos sem grau de parentesco,' + 
                    'para adicionar mais dependentes com idade menor ou igual a 64 anos é preciso respeitar o grau de parentesco dos tipos ' + 
                    'Pai, Mãe, Cônjuge, Genro e Nora.');
                }else if (this.quantidadeDependenteMaior65.parentesco65PaisMaesE1.length > 2 && this.quantidadeDependentesFilhoNetoMais30 > 0) {
                    this.arrayMsgsErro.push('Para este plano, caso haja dependentes do tipo FILHO, NETO e ENTEADO que tenham mais de 30 anos, só será possível inserir novos dependentes de qualquer grau de parentesco que tenham menos que 65 anos desde que o limite de 2 dependentes de 65 anos não tenha sido atingido.');
                }
                else{
                    this.arrayMsgsErro.pop();
                } 
            }
        } else {
            this.arrayMsgsErro.push('Este plano permite apenas 8 dependentes.');
        }

        return this;
    }
}